document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".blog-articles-slider");
  if (!sections.length || typeof Swiper === "undefined") return;

  sections.forEach((section) => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl) return;

    const slidesPerViewDesktop =
      parseInt(section.dataset.slidesPerViewDesktop, 10) || 3;
    const spaceBetween = parseInt(section.dataset.spaceBetween, 10) || 16;

    const swiper = new Swiper(swiperEl, {
      loop: false,
      centeredSlides: false,
      slidesPerView: 1.2,
      spaceBetween: 12,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
        },
        990: {
          slidesPerView: 3.2,
          spaceBetween: spaceBetween,
        },
      },
    });

    const cards = section.querySelectorAll(".blog-article-card");

    cards.forEach((card) => {
      const ripple = card.querySelector(".blog-article-card__ripple");
      let hasAnimated = false;

      card.addEventListener("mouseenter", function () {
        if (ripple) {
          ripple.classList.remove("animate");
          void ripple.offsetWidth;
          ripple.classList.add("animate");
        }
      });

      card.addEventListener("mouseleave", function () {
        if (ripple) {
          ripple.classList.remove("animate");
        }
      });
    });
  });
});

